import TableCardv2 from "../../components/TableCardv2";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import AddchartIcon from "@mui/icons-material/Addchart";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { debounce } from "lodash";
import styles from "./styles.module.css";
import { useContext, useEffect, useState, useCallback } from "react";
import { buscarProjetos } from "../../services/api-planejamento-tributario.service";
import Loading from "../../components/Loading";
import { formatValue } from "../../utils/formatValue";
import { PreviaInssContext } from "../PreviaINSS/PreviaInssContext";
import ModalVersoesProjeto from "../../components/Projeto/ModalVersoesProjeto";
import { usePreviaIcms } from "../PreviaICMS/PreviaIcmsContext";

const ProjetosICMS = () => {
  const [projetos, setProjetos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVersoes, setModalVersoes] = useState({
    open: false,
    idProjeto: null,
  });
  const [modalAnalisar, setModalAnalisar] = useState({});

  const { buscaDadosPrevia } = useContext(PreviaInssContext);
  const header = { icon: <CurrencyExchangeIcon />, title: "Projetos ICMS" };
  const functionDebounce = debounce((value) => handleDebounce(value), 1000);
  const columns = [
    { key: "razaoSocial", label: "Razão Social" },
    { key: "cnpj", label: "CNPJ" },
    { key: "categoria", label: "Categoria" },
    { key: "dtInicial", label: "Data Inicial" },
    { key: "dtFinal", label: "Data Final" },
    { key: "status", label: "Status" },
  ];

  useEffect(() => {
    handleRechargeData();
  }, []);

  const handleRechargeData = async () => {
    setLoading(true);
    try {
      const response = await buscarProjetos("icms");
      setProjetos(handleOrganizaData(response.projetos));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleInititalData = useCallback(async () => {
    setLoading(true);
    try {
      const responseProjetos = await buscarProjetos("icms");
      setProjetos(handleOrganizaData(responseProjetos.projetos));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  const handleOrganizaData = (data) => {
    const btnAnalisar = (row) => {
      return {
        icon: <QueryStatsIcon />,
        title: "Analisar",
        onClick: () => handleModalAnalisar(row),
      };
    };
    const btnVizualizar = {
      icon: <VisibilityIcon />,
      title: "Visualizar",
      onClick: () => handleClick(),
    };

    const formatStatus = (status) => {
      switch (status) {
        case "PROJETO-PENDENTE":
          return (
            <span className={styles.status_container}>
              <span className={styles.andamento} /> Andamento
            </span>
          );
        case "PROJETO-ENVIADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.enviada} /> Enviado
            </span>
          );
        case "PROJETO-APROVADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.aprovada} /> Aprovado
            </span>
          );
        case "PROJETO-CANCELADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.cancelada} /> Cancelado
            </span>
          );
        default:
          break;
      }
    };

    return data.map((item) => {
      const formatBtn = (status) => {
        switch (status) {
          case "PROJETO-PENDENTE":
            return [btnAnalisar(item)];
          default:
            return [btnVizualizar];
        }
      };
      return {
        razaoSocial: item.razaoSocial,
        cnpj: formatValue("cnpj", item.cnpj),
        categoria: item.categoriaTributaria?.descricao || "Sem categoria",
        dtInicial: formatValue("data", item.dtInicial),
        dtFinal: formatValue("data", item.dtFinal),
        status: formatStatus(item.status),
        btn: formatBtn(item.status),
      };
    });
  };

  const handleModalAnalisar = async (data) => {
    sessionStorage.setItem("cnpjSelecionado", data.cnpj);
    setModalVersoes({ open: true, idProjeto: data.idProjeto });
    setModalAnalisar(data);
  };

  const handleClick = () => {
    console.log("Visualizar projeto");
  };

  const handleDebounce = (value) => {};

  return (
    <div className={styles.container}>
      {loading ? (
        <Loading loading={loading} />
      ) : (
        <TableCardv2
          columns={columns}
          data={projetos}
          header={header}
          debounce={functionDebounce}
          loading={loading}
        />
      )}
      <ModalVersoesProjeto
        open={modalVersoes.open}
        onClose={() => setModalVersoes({ open: false, idProjeto: null })}
        idProjeto={modalVersoes.idProjeto}
        tipoProjeto="ICMS"
        contextHook={usePreviaIcms}
        dadosEmpresa={modalAnalisar}
      />
    </div>
  );
};

export default ProjetosICMS;
